import config, {onemapbase_url} from "../config";

const baseUrl = config.onemapbase_url + "agri_farm_phenology_record/";

export default {
    list: {
        url: baseUrl + "list",
        type: "get",
    },
    page: {
        url: baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
};


